import React, { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentStep, setDataV2 } from '../onboardingSlice';
import WizardNightsButton from '../components/WizardNightsButton';
import { getWizardV2State } from '../wizardService';
import { pushEvent } from '../../../utilities/analytics';
import { ONBOARDING_STEP_EVENT } from '../../../constants/analyticEvents';
import { isMobile } from '../../../utilities/helpers';
import { createPortal } from 'react-dom';

const ChildAgesStep = ({
  childIndex,
}) => {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);
  const { formV2: form, step } = useSelector(state => state.onboarding);
  const { who } = form;
  const data = getWizardV2State().whoStep;
  const footerPortal = document.getElementById('wizard-next-button');

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    }
  }, [])

  const onCardClick = (item) => () => {
    const childAges = [...who?.capacity?.childAges];
    childAges[childIndex] = item;

    dispatch(setDataV2({ who: {
      ...who,
      capacity: {
        ...who?.capacity,
        childAges,
      }
    }}))

    timeoutRef.current = setTimeout(() => {
      if (childIndex === who.capacity.children - 1) {
        pushEvent(ONBOARDING_STEP_EVENT, {
          step,
          stepName: 'childAges',
          question: 'Select child ages',
          selection: childAges,
          skipAvailable: !!(localStorage.getItem('onboardingCompleted')),
        });
      }

      dispatch(setCurrentStep(1));
    }, 500);
  }

  const renderChildAges = () => {
    let childAges = [];

    if (!who?.capacity?.childAges.some(age => age < 2) || who.capacity.childAges[childIndex] < 2) {
      childAges.push(
        <WizardNightsButton
          key={1}
          label={data.childSelection.infantAgeText}
          className="col-span-2"
          onClick={onCardClick(1)}
          active={who?.capacity?.childAges?.[childIndex] === 1}
        />
      )
    }

    for (let i = 2; i < 18; i++) {
      childAges.push(
        <WizardNightsButton
          key={i}
          label={i}
          onClick={onCardClick(i)}
          active={who?.capacity?.childAges?.[childIndex] === i}
        />
      )
    }

    return childAges;
  }

  const getColoredText = (text) => {
    const parts = text.split(/\*(.*?)\*/g);

    const elements = parts.map((part, i) =>
      i % 2 === 0
        ? part
        : <span key={i} className="wizard-child-colored animated fade-in">{part}</span>
    );

    return <div>{elements}</div>;
  }

  return (
    <div className="wizard-step wizard-child-ages-step">
      <div className="slide-in-bottom">
        <div>
          <div className="wizard-step__title">
            {who.capacity.children === 1
              ? data.childSelection.childAgesTitle.single
              : getColoredText(data.childSelection.childAgesTitle[childIndex + 1])
            }
          </div>
          <div className="wizard-step__options grid-cols-5 animated fade-in">
            {renderChildAges()}
          </div>
        </div>
      </div>

      {!isMobile() && footerPortal && createPortal(
        <button className="wizard-btn wizard-btn--next" onClick={() => dispatch(setCurrentStep(1))}>
          {data.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </div>
  )
}

export default ChildAgesStep
